import { tracked } from '@glimmer/tracking';

import FilterSortGoalOKRs from 'webapp/models-custom/filter-sort/goal-okrs';

export default class FilterSortGoalOKRsInList extends FilterSortGoalOKRs {
	@tracked override viewId = 'table';
	override itemDomSelector = '.table-row:not(.empty)';
}
